/**
 * Shared axios client + interceptors.
 * NEW domain-service modules (services/*API.js) should `import { client } from './client'`
 * and define their endpoints here. `services/api.js` remains as a backward-compat barrel
 * that re-exports everything so existing imports keep working during the migration.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const client = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { API_URL };
export default client;
